var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,{tag:"component",staticClass:"cell-vertical-divider"},[_c('div',_vm._b({class:{ [`${_vm.color}-cell-divider`]: true }},'div',_vm.$attrs,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }